export default {
  headerContent: {
    title: 'Mapfre Sigorta Kasko Sigortası Teklifi Hesaplama',
    slogan: "Araç Kasko Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'ARAÇ KASKO SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Mapfre Sigorta Araç Kasko Sigortası',
    description: {
      title: 'Mapfre Sigorta Araç Kasko Sigortası Nedir? ',
      content: [
        'Kasko sigortası, aracınızı günlük olarak karşılaşabileceği risklere karşı güvence altına alan sigorta çeşididir. Bir arabanız varsa, bunun büyük bir sorumluluk olduğunu biliyorsunuz. Ödemelerden bakıma kadar, üstlenilmesi gereken çok şey var. Bir araba satın alma taahhüdünü vermeden önce birçok kişinin düşünmesi gereken bir şey, onunla birlikte gelen sigortadır.',
        'Otomobil sigortası gereksinimleri kişiden kişiye değişir. En doğru teminatları <strong><em><u>alokasko.com</u></em></strong> ile seçebilirsiniz!'
      ]
    },
    subContent: {
      title: 'Mapfre Sigorta Araç Kasko Sigortası Zorunlu Mu?',
      content: [
        {
          paragraph:
            'Kasko sigortası, isteğe bağlı sigorta ürünüdür. Hem araç sahibini hem de aracını güvence altına alan kasko sigortasını yaptırmak tamamen sürücüye bağlıdır. 1 yıllık güvence sunan araç kasko sigortasını Mapfre Sigorta’dan yaptırarak olası bir çok riske karşı korumanızı bugün başlatabilirsiniz.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Araç Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Araç Kasko Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Araç Kasko Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Araç Kasko Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Araç Kasko Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Mapfre Sigorta Araç Kasko Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
